import AsyncStorage from "@react-native-async-storage/async-storage";
import { Text, TouchableOpacity, View, Image } from "react-native";
import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { LinearGradient } from "expo-linear-gradient";
import { FormattedMessage } from "react-intl";
import api from "../../services/api";
import styles from "./styles";

const SelosSectionMobile = () => {
  const navigation = useNavigation();
  const [selos, setSelos] = useState([]);
  const [selectedSelo, setSelectedSelo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState("");
  const getSeloSustentavelCategory = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    try {
      const response = await api.get("/categories", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const categories = Array.isArray(response.data[0])
        ? response.data[0]
        : [];

      const foundCategory = categories.find((category) =>
        category.name.includes("Selo")
      );

      if (foundCategory) {
        setCategoryName(foundCategory.name);
      }

      return foundCategory;
    } catch (error) {
      console.error("Erro ao buscar categoria 'Selo Sustentável'", error);
      return null;
    }
  };

  const getSelos = async () => {
    const seloCategory = await getSeloSustentavelCategory();

    if (!seloCategory) {
      console.error("Categoria 'Selo Sustentável' não encontrada");
      return;
    }

    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading(true);

    try {
      const response = await api.get(`/actives/getActives/${seloCategory.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const selosList = response.data.active || [];
      const filteredSelos = selosList.filter(
        (item) => item.single_value >= 0.5
      );
      setSelos(filteredSelos);
    } catch (error) {
      console.error("Erro ao buscar selos", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selo = selos.find((selo) => selo.id == selectedValue);
    setSelectedSelo(selo);
  };

  useEffect(() => {
    getSelos();
  }, []);

  return (
    <LinearGradient
      start={{ x: 1, y: 0.99 }}
      end={{ x: 0.2, y: 0 }}
      colors={["#0B87AB", "#0084CE"]}
    >
      <View style={styles.mainContainer}>
        <View style={styles.rightColumnContainer}>
          <Text style={styles.mainHeaderTxt}>
            <FormattedMessage id="selosSection.mainHeader" />
          </Text>

          <View style={styles.pickerContainer}>
            <FormattedMessage id="selosSection.selectPlaceholder">
              {(optionActive) => (
                <select
                  value={selectedSelo ? selectedSelo.id : ""}
                  onChange={handleSelectChange}
                  style={{
                    color: "#FFF",
                    backgroundColor: "#043569",
                    padding: "10px",
                    borderRadius: "4px",
                    width: "90%",
                    fontSize: "16px",
                    border: "none",
                  }}
                >
                  <option value="" disabled>
                    {optionActive}
                  </option>
                  {selos.map((selo) => (
                    <option key={selo.id} value={selo.id}>
                      {selo.name_token}
                    </option>
                  ))}
                </select>
              )}
            </FormattedMessage>
          </View>

          {selectedSelo && (
            <View style={styles.cardContainer}>
              <View style={styles.cardRightColumnContainer}>
                <Text style={styles.titleTxtSelo}>
                  {selectedSelo.name_token}
                </Text>
                <Text style={styles.subtitleTxtSelo}>
                  <FormattedMessage id="selosSection.btnTxtCarbonoNeutro" />
                </Text>
                <Text style={styles.descriptionTxtSelo}>
                  {selectedSelo.description ||
                    "Descrição padrão caso não exista."}
                </Text>
                <View style={styles.containerRowBtns}>
                  <Image
                    source={{
                      uri:
                        "https://filesgpx.s3.us-east-2.amazonaws.com/" +
                        selectedSelo.path,
                    }}
                    style={styles.imageSelo}
                    resizeMode="contain"
                  />
                  <View style={{ gap: 10 }}>
                    <TouchableOpacity
                      style={styles.btnComprar}
                      onPress={() =>
                        navigation.navigate("Purchase", {
                          viewType: "buy",
                          selectedActive: selectedSelo.id,
                        })
                      }
                    >
                      <Text style={styles.txtBtn}>
                        <FormattedMessage id="selosSection.btnTxtComprar" />
                      </Text>
                    </TouchableOpacity>
                    <TouchableOpacity
                      style={styles.btnSaibaMais}
                      onPress={() =>
                        navigation.navigate("MoreInfosCoin", {
                          id: selectedSelo.id,
                          categoryName,
                        })
                      }
                    >
                      <Text style={styles.txtBtn}>
                        <FormattedMessage id="selosSection.btnTxtSaibaMais" />
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            </View>
          )}
        </View>
      </View>
    </LinearGradient>
  );
};

export default SelosSectionMobile;
